import deepFreeze from 'deep-freeze';
import serviceFactory from '@/services/serviceFactory';

export const ENDPOINTS = deepFreeze({
    CATEGORIES: {
        URI: () => '/api/v1/categories',
        methods: ['get'],
    },
    BUYBOX_CATEGORIES: {
        URI: () => '/api/v1/buybox-categories',
        methods: ['get'],
        default: [],
        formatter: data => data?.items || [],
    },
});

export default {
    ...serviceFactory.build(ENDPOINTS),
};
